import React from 'react';
import { Trans } from 'react-i18next';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import Button from '../../../../../../Components/Button/button';
import styles from './mnuItemIsActive.module.scss';

interface IProps {
    title:string,
    onClick:()=>void,
    onClose:()=>void,
    loading:boolean
}

const MenuItemIsActive:React.FC<IProps> = (props) => {
    const {title,onClick,onClose,loading} = props;
    const { t } = useLanguagesHooks();

  return (
    <div className={styles.container}>
            <div className={styles.header}>
                <p>
                    {t('My_Business.Handle_IsActive.Header')}
                </p>
            </div>
            <div className={styles.content}>
            <div className={styles.text}>
                <Trans
                    i18nKey="My_Business.Handle_IsActive.Text"
                    values={{ title }}
                    components={{
                        strong: <span className={styles.itemTitle} />,
                    }}
                />
                </div>
                <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Cancel')}
                        type='button'
                        onClick={onClose}
                        buttonStyle={styles.button}
                    />
                    <Button
                        buttonType={ButtonTypes.Primery}
                        title={t('Buttons.Confirm')}
                        type='button'
                        onClick={onClick}
                        isLoading={loading}
                        buttonStyle={styles.button}
                    />
                </div>
            </div>
        </div>
  )
}

export default MenuItemIsActive
